import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  rightSection: {
    minHeight: "78vh",
    "& .MuiCard-root": {
      height: "100%",
    },
    [theme.breakpoints.up("xs")]: {
      width: "calc(100% - 290px)",
      marginLeft: 24,
    },
    "& .MuiButtonBase-root": {
      "& .MuiButton-endIcon": {
        display: "none",
      },
    },
    "& .k-grid-header": {
      padding: "0 !important",
    },
  },
  headerSection: {
    width: "calc(100% - 250px)",
    "& .MuiFormControl-root": {
      width: 230,
      marginRight: 10,
    },
    "& .MuiInputLabel-formControl": {
      margin: 0,
    },
  },
  checkinType: {
    borderBottom: "solid 1px #ECEEF2",
    padding: "16px 24px",
  },
  media: {
    "& img, & video": {
      width: "100%",
      height: 120,
    },
  },
  subTable: {
    margin: "-10px -12px",
    "& .k-grid-header": {
      display: "none",
    },
    "& .k-master-row": {
      "& td": {
        background: "#F5F5F5",
      },
    },
  },
  rating: {
    pointerEvents: "none",
  },
  avgRating: {
    pointerEvents: "none",
    "& svg": {
      fontSize: 28,
    },
  },
  emojiBarChart: {
    "& image": {
      width: 35,
      height: 35,
    },
  },
  emojiImages: {
    width: 36,
    display: "block",
  },
  donutChart: {
    "& .k-chart": {
      height: "200px !important",
      "& .k-chart-donut-center": {
        "& span": {
          "& h2": {
            fontSize: 20,
          },
          "& h4": {
            fontSize: 15,
          },
        },
      },
    },
  },
  starRatingSummary: {
    "& .k-chart": {
      height: 200,
    },
  },
  correctIcon: {
    color: "#009C55",
  },
  gridDataChart: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  emojiImage: {
    display: "block",
    width: 30,
  },
  chartList: {
    display: "flex",
    alignItems: "center",
    margin: "15px 0",
  },
  yAxisLabel: {
    width: 90,
    fontSize: 12,
    color: "#525252",
    marginRight: 12,
    marginLeft: 6,
  },
  descriptiveStatistics: {
    "& ul": {
      margin: 0,
      padding: 0,
      listStyle: "none",
    },
    "& .k-gauge": {
      width: 65,
      height: 65,
    },
    "& h6": {
      lineHeight: "24px",
    },
  },
  response: {
    width: "40%",
  },
  questionTxt: {
    width: "60%",
  },
  gridDetails: {
    margin: 0,
    padding: "0 0 0 15px",
    "& li": {
      borderBottom: "solid 1px rgb(204 204 204 / 80%)",
      padding: "10px 0",
    },
    "& .no-data-img": {
      minHeight: 200,
    },
  },
  questionHeader: {
    "& span": {
      background: "#FCFCFD",
      position: "absolute",
      paddingRight: 10,
    },
    position: "relative",
    height: 30,
    "&:before": {
      width: "100%",
      height: 1,
      background: "rgb(204 204 204 / 80%)",
      content: '""',
      position: "absolute",
      top: 10,
    },
  },
  commentBlock: {
    borderTop: "solid 1px #E1E4EA",
  },
  surveySubTable: {
    paddingRight: 48,
    "& table": {
      borderSpacing: 0,
    },
    "& .k-grid-header": {
      background: "none",
      borderBottom: "solid 1px #E1E4EA",
      "& th:hover": {
        background: "none !important",
      },
    },
    "& tr:last-child": {
      "& td": {
        border: "none !important",
      },
    },
    "& td": {
      borderTop: "none !important",
      borderLeft: "none !important",
      borderRight: "none !important",
      borderRadius: 0,
      verticalAlign: "top",
      height: "auto",
      padding: "16px 12px",
      background: "none !important",
      "&:first-child, &:last-child": {
        borderTop: "none !important",
        borderLeft: "none !important",
        borderRight: "none !important",
        borderRadius: 0,
      },
    },
    "& .k-header .k-link:hover::after": {
      content: "none",
    },
    "& .k-icon": {
      display: "none",
    },
    "& .incorrect-ans": {
      color: "#FF7575 !important",
    },
  },
  subTableHeader: {
    margin: "0 -12px",
    "& .MuiLinearProgress-root": {
      width: 320,
      [theme.breakpoints.down("md")]: {
        width: 260,
      },
    },
    "& .x-axis": {
      width: 320,
      [theme.breakpoints.down("md")]: {
        width: 260,
        marginLeft: 34,
      },
    },
    "& .donut-summary": {
      display: "none",
    },
    "& .k-chart": {
      height: "200px !important",
      width: "400px !important",
    },
    [theme.breakpoints.down("md")]: {
      "& .main-list": {
        marginLeft: 35,
      },
    },
    "@media(max-width: 1024px)": {
      "& .main-list": {
        "&:before": {
          left: 107,
        },
        "& .qus-label": {
          position: "static",
          width: 100,
          marginRight: 2,
        },
        "& .MuiLinearProgress-root": {
          width: 175,
        },
      },
      "& .x-axis": {
        marginLeft: "142px !important",
        width: "180px !important",
        marginTop: -16,
      },
    },
  },
  userStatus: {
    position: "absolute",
    bottom: -5,
    left: -5,
    width: 18,
    height: 18,
    border: "solid 1px #CECECE",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
  },
  checkIcon: {
    color: "#36A07D",
  },
  closeIcon: {
    color: "#FF7575",
  },
  starIcon: {
    color: "#FAC129",
  },
  grayStar: {
    color: "#CAD4DD",
  },
  starOverlap: {
    position: "absolute",
    top: 0,
  },
  multiWrap2: {
    whiteSpace: "pre",
  },
  resIcon: {
    minWidth: 10,
    marginRight: 8,
    marginTop: 5,
  },
  attachmentList: {
    margin: 0,
    padding: 0,
    listStyle: "none",
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
    "& li": {
      borderBottom: "1px solid rgb(112 112 112 / 16%)",
      display: "flex",
      alignItems: "center",
      padding: "10px 0",
      "&:last-child": {
        border: "none",
      },
      "& img": {
        width: 25,
        minWidth: 25,
        marginRight: 10,
        height: "auto",
      },
      "& svg": {
        width: 25,
        minWidth: 25,
        marginRight: 10,
        height: "auto",
      },
    },
  },
}));
